import { FC } from 'react'
import { Typography, useTheme } from '@mui/material'

export const HICTitleSmall: FC = ({ children }) => {
  const theme = useTheme()

  return (
    <Typography color={theme.palette.secondary.dark}>
      <strong>{children}</strong>
    </Typography>
  )
}
